import fotaApi from '@/api/api.fota'
export default [
  {
    type: 'input',
    placeholder: '设备ID',
    filed: 'deviceCode',
    default: ''
  },
  {
    type: 'select',
    placeholder: '固件版本',
    filed: 'version',
    default: '',
    query: fotaApi.firmware_list + '?firmwareType=LOWER',
    labelOptions: {
      key: 'version',
      value: 'version'
    }
  }
]
